import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_holidays_spring: FaireCategoryEntity = {
  token: "cat_holidays-spring",
  type: "category",
  name: "Spring",
  level: 2,
  parentToken: "cat_holidays-seasonal",
  href: "/category/spring",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
